import addModifier from '../../../../actions/shop/modifier/addModifier';
import addItemModifier from '../../../../actions/shop/modifier/addItemModifier';

// Conversion factors to grams
const unitToGrams = {
    gr: 1,
    kg: 1000,
    ml: 1, // assuming 1ml = 1g for water-like substances
    l: 1000
};

async function submit(values, dispatch) {
    let minModifierItems = values.modifierType == "2" ? values.minModifierItems : 0;
    // Convert each modifierItem's originalWeight and weightUnit to grams and store as weight
    let modifierItems = (values.modifierItems || []).map(item => {
        let weight = null;
        if (item.originalWeight != null && item.weightUnit) {
            const numericWeight = parseFloat(item.originalWeight);
            const unit = item.weightUnit.toLowerCase();
            const conversionFactor = unitToGrams[unit] || 1;
            if (!isNaN(numericWeight)) {
                weight = numericWeight * conversionFactor;
            }
        }
        return {
            ...item,
            weight,
            // keep originalWeight and weightUnit for display if needed
            weightUnit: item.weightUnit
        };
    });

    let modifierItemsString = JSON.stringify(modifierItems);
    if (values.modifierFrom === 'item') {
        let variables = Object.assign({}, values, {
            minModifierItems,
            modifierItems
        });
        await dispatch(addItemModifier(variables));
    } else {
        let variables = Object.assign({}, values, {
            minModifierItems
        }, {
            modifierItems: modifierItemsString
        });
        await dispatch(addModifier(variables));
    }
}

export default submit;